import { render, staticRenderFns } from "./ApprovalView.vue?vue&type=template&id=373ce362&"
import script from "./ApprovalView.vue?vue&type=script&lang=js&"
export * from "./ApprovalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports